import { AIMessage } from 'components'
import { SUPPORT_STATUS } from 'app-constants'
import {
  HasConnection,
  HasMassive,
  HasOS,
  NoMatchingRule,
  IneligibleContract,
  ScheduleRepair,
  OtherConnectionProblems,
} from './components'
import './style.scss'

const COMPONENTS_BY_STATUS = {
  [SUPPORT_STATUS.NO_MATCHING_RULE]: NoMatchingRule,
  [SUPPORT_STATUS.HAS_OS]: HasOS,
  [SUPPORT_STATUS.HAS_CONNECTION]: HasConnection,
  [SUPPORT_STATUS.HAS_MASSIVE]: HasMassive,
  [SUPPORT_STATUS.INELIGIBLE_CONTRACT]: IneligibleContract,
  [SUPPORT_STATUS.SCHEDULE_REPAIR]: ScheduleRepair,
  [SUPPORT_STATUS.OTHER_CONNECTION_PROBLEMS]: OtherConnectionProblems,
}

export function SupportResponse({ data }) {
  const { supportStatus, message } = data

  function renderContent() {
    const Component = COMPONENTS_BY_STATUS[supportStatus]

    if (!Component) return null

    return <Component data={data} />
  }

  return (
    <div className='support-response-container'>
      <AIMessage message={message}>{renderContent()}</AIMessage>
    </div>
  )
}
